export const userListColumns = [
  {
    Header: "User Id",
    accessor: "id",
  },
  {
    Header: "First Name",
    accessor: "first_name",
  },
  {
    Header: "Middle Name",
    accessor: "middle_name",
  },
  {
    Header: "Last Name",
    accessor: "last_name",
  },
  {
    Header: "User Name",
    accessor: "username",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Phone no",
    accessor: "phone",
  },
  {
    Header: "Role",
    accessor: "role",
  },
  {
    Header: "Created At",
    accessor: "created_at",
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
  },
  {
    Header: "Status",
    accessor: "status",
  },
];
